export default "__VITE_PUBLIC_ASSET__7a68301b__"